module.exports = __webpack_public_path__ + "static/media/r2.b06db848.jpg";